// ── participant-detail-section: the shared read-section wrapper (Wave 4) ────
// Mirrors cohort-tab-shell. Each participant-detail panel wraps its OWN
// useHonestQuery -> <HonestState> read; this thin shell renders the section
// chrome (a Module card with a head) + the honest body so each panel stays small
// and consistent. The body renders ONLY when posture is null (ready); otherwise
// the honest state shows. Loading uses the rows skeleton so a panel body is never
// a blank.

import type { ReactNode } from "react";
import { Module, ModuleBody, ModuleHead } from "@vjal/ui";

import { HonestState } from "../../../components/honest-state";
import type { HonestGate } from "../../../services/coaching-error-posture";
import type { HonestPosture } from "../../../components/honest-state";

export interface ParticipantDetailSectionProps {
  title: string;
  subtitle?: string;
  posture: HonestPosture | null;
  gate?: HonestGate | null;
  reference?: string | null;
  onRetry?: () => void;
  emptyTitle?: string;
  emptyMessage?: string;
  /** Rendered only when posture === null (ready-with-data). */
  children: ReactNode;
}

export function ParticipantDetailSection({
  title,
  subtitle,
  posture,
  gate,
  reference,
  onRetry,
  emptyTitle,
  emptyMessage,
  children
}: ParticipantDetailSectionProps) {
  return (
    <Module span={12}>
      <ModuleHead title={title} subtitle={subtitle} />
      <ModuleBody className="space-y-4">
        {posture !== null ? (
          <HonestState
            posture={posture}
            gate={gate}
            reference={reference}
            onRetry={onRetry}
            loadingVariant="rows"
            title={posture === "empty" ? emptyTitle : undefined}
            message={posture === "empty" ? emptyMessage : undefined}
          />
        ) : (
          children
        )}
      </ModuleBody>
    </Module>
  );
}
